import { GridComponent, ELoadingStatus } from './components/grid.component';
import { WorkBook, read as readExcelFile, writeFile as writeExcelFile, utils as excelUtils } from 'xlsx';
import { GridHeaderModel, GridCellModel, GridRowModel, CellStyles, GridContainerStyle, HeaderStyles } from './models/grid';

import { 
  Component, 
  OnInit,
  OnChanges,
  OnDestroy,
  Input,
  Output,
  SimpleChanges,
  EventEmitter,
  TemplateRef,
  ViewChild,
  NgZone,
  Inject,
  forwardRef
} from '@angular/core';

import { isEqual, isNil, isEmpty, set } from 'lodash-es';
import { Subject } from 'rxjs';
import { takeUntil, mergeMap, shareReplay } from 'rxjs/operators';
import { BaseComponent } from './components/base.component';
import { SharedModule } from './shared.module';import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DatexFormControl, validateControlOnChange, validateFormOnControlChange } from './models/datex-form-control';
import { Styles, ControlContainerStyles } from './models/style';
import { FieldModel } from './models/field';
import { FieldsetModel } from './models/fieldset';
import { ToolModel } from './models/tool';
import { 
  TextBoxModel, 
  NumberBoxModel, 
  SelectBoxModel, 
  ESelectBoxType,
  DateBoxModel, 
  CheckBoxModel, 
  TextModel, 
  LabelModel, 
  ButtonModel,
  SplitButtonModel,
  SeparatorModel,
  ImageModel,
  DrawModel,
  CodeBoxModel,
  ButtonStyles,
  ValueControlModel
} from './models/control';
import { datCodeValidator } from './components/code-validator.directive';import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';
import { ProgrammableLogicController_ShellService } from './ProgrammableLogicController.shell.service';
import { ProgrammableLogicController_OperationService } from './ProgrammableLogicController.operation.service';
import { ProgrammableLogicController_DatasourceService } from './ProgrammableLogicController.datasource.index';
import { ProgrammableLogicController_FlowService } from './ProgrammableLogicController.flow.index';
import { ProgrammableLogicController_FrontendFlowService } from './ProgrammableLogicController.frontend.flow.service';
import { ProgrammableLogicController_ReportService } from './ProgrammableLogicController.report.index';
import { ProgrammableLogicController_LocalizationService } from './ProgrammableLogicController.localization.service';
import { ProgrammableLogicController_connectors_grid_ComponentContextService } from './ProgrammableLogicController.connectors_grid.component.context.service';
import { Language } from './localization.service';
import { JobStatus } from './common-interfaces'
import { ApplicationType, ComponentType } from './app-context.service';
import { CleanupLoggerService } from './cleanup.logging.service';
import { $frontendTypes} from './ProgrammableLogicController.frontend.types'
import { $frontendTypes as $types} from './ProgrammableLogicController.frontend.types' 

import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';


interface IProgrammableLogicController_connectors_gridComponentEntity {
  name?: string, warehouseId?: number, type?: string, projectId?: number, orderClassId?: number}



class ProgrammableLogicController_connectors_gridComponentRowModel extends GridRowModel {
  grid: ProgrammableLogicController_connectors_gridComponent;
  entity: IProgrammableLogicController_connectors_gridComponentEntity;



 // temporarily put required on all edit controls
  override formGroup = new FormGroup({
  });

  override cells = {
    type: null,
    name: null,
    warehouse: null,
    project: null,
    order_class: null,
  }



  constructor(
    grid: ProgrammableLogicController_connectors_gridComponent,
    private $utils: UtilsService,
private $settings: SettingsValuesService,
private $shell: ProgrammableLogicController_ShellService,
private $datasources: ProgrammableLogicController_DatasourceService,
private $flows: ProgrammableLogicController_FlowService,
private $frontendFlows: ProgrammableLogicController_FrontendFlowService,
private $reports: ProgrammableLogicController_ReportService,
private $localization: ProgrammableLogicController_LocalizationService,
private $operations: ProgrammableLogicController_OperationService,
private $logger: CleanupLoggerService,
private $context: ProgrammableLogicController_connectors_grid_ComponentContextService,
) {
    super();

    this.grid = grid;

    this.cells.type = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.type,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.name = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.name,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.warehouse = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.warehouse,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.project = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.project,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    this.cells.order_class = new GridCellModel(
      new CellStyles(null, null),
      this.grid.headers.order_class,
      new TextModel(null, null, null, null, null)
,
null
      );
    
    
  }

  async $initializeExisting(entity: IProgrammableLogicController_connectors_gridComponentEntity) {
    this.entity = entity;

    this.rowId = [this.entity.name].join('-');

    await this.$dataLoaded();
  }

  async $initializeNew(entity?: IProgrammableLogicController_connectors_gridComponentEntity) {
    this.isNew = true;

    if (entity) {
      this.entity = entity;
    }
    else {
      this.entity = {};
    }

    this.rowId = [this.entity.name].join('-');
    await this.$dataLoaded();
    // mark the whole form as dirty, since this is a new row 
    // and even if it is valid, it should have a changed state
    this.formGroup.markAsDirty();
  }

  private $unsubscribe$ = new Subject();
  override destroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();
  }

  $init() {
  }

  async $dataLoad() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    const $resultKey = this.entity.name;
    const $inParams: { fullTextSearch?: string, $keys: string[] } = {
      $keys:[$resultKey],
      fullTextSearch:  null ,
    };
    const $data = await this.$datasources.ProgrammableLogicController.ds_connectors_grid.getByKeys($inParams);
    
    await this.grid.$applyLinkedDatasourcesAndCustomColumns($inParams, $data);
      
    this.entity = $data.result[0] as IProgrammableLogicController_connectors_gridComponentEntity;
    await this.$dataLoaded();
  }

  async $dataLoaded() {
    const $row = this;
    const $grid = this.grid;
    const $utils = this.$utils;
    (this.cells.type.displayControl as TextModel).text = $row.entity.type;
    (this.cells.name.displayControl as TextModel).text = $row.entity.name;

  }

  override async refresh() {
    await this.$dataLoad();
    // grid refresh skipSelf=true, skipParent=false, skipChildren=false  
    this.grid.$refreshEvent.emit();
  }

  override async save() {
    if (this.isNew) {
    } else {
    } 
  }

  override $cellClicked(cellId: string) {
    super.$cellClicked(cellId);
    switch(cellId) {
    }
  }


}


@Component({
  imports: [
    SharedModule,
  ],
  selector: 'ProgrammableLogicController-connectors_grid',
  templateUrl: './ProgrammableLogicController.connectors_grid.component.html'
})
export class ProgrammableLogicController_connectors_gridComponent extends BaseComponent implements OnInit, OnDestroy {
  //#region Outputs
  @Output()
  $finish = new EventEmitter();
  @Output()
  $refreshEvent = new EventEmitter();
  //#endregion Outputs

  entities: IProgrammableLogicController_connectors_gridComponentEntity[];

  pageSize = 10;
  pageSkip = 0;
  totalCount = 0;
  loadingStatus = ELoadingStatus.Loading;


// to stop add from flow
// canAdd = false; //hide add button, check on exitFromLastCell 
// bottomToolbar.addLine.hidden = true; //hide add button, no check on exitFromLastCell 
// bottomToolbar.addLine.control.readOnly = true; //disable add button, check on exitFromLastCell 
 
  
  containerStyles: GridContainerStyle = new GridContainerStyle('cellsWidth', ['default','fit-content-table']);




  //#region Variables
  //#endregion
  //#region Events
  
  //#endregion

  headers = {
     type: new GridHeaderModel(new HeaderStyles(null, null), 'type', 'Type', false, false, null, false),       name: new GridHeaderModel(new HeaderStyles(null, null), 'name', 'Name', false, false, null, false),       warehouse: new GridHeaderModel(new HeaderStyles(null, null), 'warehouse', 'Warehouse', false, false, null, false),       project: new GridHeaderModel(new HeaderStyles(null, null), 'project', 'Project', false, false, null, false),       order_class: new GridHeaderModel(new HeaderStyles(null, null), 'order_class', 'Order class', false, false, null, false),  
  };

  //#region title
  // Make it async so that it won't cause expressionChangedAfterItHasBeenCheckedError
  // The title is often meant to be shown from the parent (shell breadcrumb for example)
  // and often it will cause an expressionChangedAfterItHasBeenCheckedError because 
  // the parent has already been checked and the child now change something on the parent 
  // in dev, CD is run twice
  $titleChange = new EventEmitter<string>(true);
  private $_title: string;
  get title(): string {
    return this.$_title;
  }
  set title(t: string) {
    this.$_title = t;
    this.$titleChange.emit(this.$_title);
  }
  //#endregion title
  rows: ProgrammableLogicController_connectors_gridComponentRowModel[] = [];


  topToolbar = {
      new_connector: new ToolModel(new ButtonModel('new_connector', new ButtonStyles(['creation'], null), false, false, false, 'New connector', 'icon-ic_fluent_add_20_regular', null)
    , false),
      separator1: new ToolModel(new SeparatorModel(new Styles(null, null))
    , false),
      delete_button: new ToolModel(new ButtonModel('delete_button', new ButtonStyles(['destructive'], null), false, false, false, 'Delete', 'icon-ic_fluent_delete_20_regular', null)
    , false)
  };

  bottomToolbar = {
  };




  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    private $shell: ProgrammableLogicController_ShellService,
    private $datasources: ProgrammableLogicController_DatasourceService,
    private $flows: ProgrammableLogicController_FlowService,
    private $frontendFlows: ProgrammableLogicController_FrontendFlowService,
    private $reports: ProgrammableLogicController_ReportService,
    private $localization: ProgrammableLogicController_LocalizationService,
    private $operations: ProgrammableLogicController_OperationService,
    private $logger: CleanupLoggerService,
    private $context: ProgrammableLogicController_connectors_grid_ComponentContextService,
    ) {
    super();
    this.title = 'Connectors';
    this.$subscribeFormControlValueChanges();
  }

  ngOnInit(): void {
    this.$init();
  }
  


  initialized = false;

  private $unsubscribe$ = new Subject();
  ngOnDestroy(): void {
    this.$unsubscribe$.next(null);
    this.$unsubscribe$.complete();

    this.clearRows();
  }

  async $init() {
    const $grid = this;
    const $utils = this.$utils;

    this.pageSize = 10;


    this.initialized = true;

    this.pageSkip = 0;
    this.refresh(true, true, null);
  }

  protected override $initEmpty() {
    this.clearRows();
  }

  private $subscribeFormControlValueChanges() {

  }

  reload() {
    this.pageSkip = 0;
    this.refresh();
  }

  refresh(
    skipParent = false,
    skipChildren = false,
    childToSkip: string = null) {
    // up
    if (skipParent === false) {
      this.$refreshEvent.emit();
    }

    // self
    const result = this.$dataLoad();

    // children
    if (skipChildren === false) {
    }

    return result;
  }

  async $dataLoad() {
    this.loadingStatus = ELoadingStatus.Loading;
    const $grid = this;
    const $utils = this.$utils;
    const $inParams: { fullTextSearch?: string, $top?: number, $skip?: number } = {
      $top: this.pageSize,
      $skip: this.pageSkip,
      fullTextSearch:  null ,
    };
    try {
      const $data = await this.$datasources.ProgrammableLogicController.ds_connectors_grid.getList($inParams);
      
      await this.$applyLinkedDatasourcesAndCustomColumns($inParams, $data);

      this.entities = $data.result as IProgrammableLogicController_connectors_gridComponentEntity[];
      this.totalCount = $data.totalCount;

      await this.$dataLoaded();
      
      if (this.totalCount === 0) {
        this.loadingStatus = ELoadingStatus.NoResults;
      } else {
        this.loadingStatus = ELoadingStatus.Loaded;
      }
    } catch(error) {
      console.error("Error loading data:", error);
      this.loadingStatus = ELoadingStatus.Error;
    }
  }

  async $dataLoaded() {
    const $grid = this;
    const $utils = this.$utils;
    
    this.clearRows();

    if(this.entities) {
      let rowLoadPromises = [];
      for (let entity of this.entities) {
        const row = new ProgrammableLogicController_connectors_gridComponentRowModel(
          this,
          this.$utils,
          this.$settings,
          this.$shell, 
          this.$datasources,
          this.$flows,
          this.$frontendFlows,
          this.$reports,
          this.$localization,
          this.$operations,
          this.$logger,
          this.$context);
        rowLoadPromises.push(row.$initializeExisting(entity));
        this.rows.push(row);
      }
      await Promise.all(rowLoadPromises);
    }

    await this.on_grid_data_load();
  }

  
    async $applyLinkedDatasourcesAndCustomColumns($inParams: any, $outParams: any) {
      const $datasource = { inParams: $inParams };
      const $utils = this.$utils;
  
    }

  clearRows() {
    if(this.rows && this.rows.length) {
      this.rows.forEach(r => r.destroy());
    }
    this.rows = [];
  }

  selectedRows: ProgrammableLogicController_connectors_gridComponentRowModel[] = [];
  hasSelectedRows() {
    return this.selectedRows.length > 0;
  }

  async $selectionChanged(selectedRows: any[]) {
    this.selectedRows = selectedRows;
  }

  
  openImageViewer(imageSource: string) {
    this.$shell.openImageViewerDialog(imageSource);
  }

  //#region private flows
  on_new_connector_clicked(event = null) {
    return this.on_new_connector_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$frontendFlows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_new_connector_clickedInternal(
    $grid: ProgrammableLogicController_connectors_gridComponent,
  
    $shell: ProgrammableLogicController_ShellService,
    $datasources: ProgrammableLogicController_DatasourceService,
    $flows: ProgrammableLogicController_FlowService,
    $frontendFlows: ProgrammableLogicController_FrontendFlowService,
    $reports: ProgrammableLogicController_ReportService,
    $settings: SettingsValuesService,
    $operations: ProgrammableLogicController_OperationService,
    $utils: UtilsService,
    $context: ProgrammableLogicController_connectors_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ProgrammableLogicController_LocalizationService,
    $event: any
  ) {
    this.$logger.log('ProgrammableLogicController', 'connectors_grid.on_new_connector_clicked');
  
  
  
  let configurations = (await $shell.ProgrammableLogicController.openconfiguration_formDialog("flyout"))
  
  
  if ($utils.isDefined(configurations?.connector_name)) {
      try {
  
          await $flows.ProgrammableLogicController.insert_connectors({
              name: configurations.connector_name,
              type: configurations.connector_type,
              warehouseId: configurations.warehouse,
              projectId: configurations.project,
              orderClassId: configurations.order_class
          })
  
          $grid.refresh();
  
      } catch (error) {
          $shell.Utilities.showErrorDetails('Save', 'Error on save.', error);
          throw error; // to prevent displayMode 
      }
  
  
  }
  }
  on_delete_clicked(event = null) {
    return this.on_delete_clickedInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$frontendFlows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_delete_clickedInternal(
    $grid: ProgrammableLogicController_connectors_gridComponent,
  
    $shell: ProgrammableLogicController_ShellService,
    $datasources: ProgrammableLogicController_DatasourceService,
    $flows: ProgrammableLogicController_FlowService,
    $frontendFlows: ProgrammableLogicController_FrontendFlowService,
    $reports: ProgrammableLogicController_ReportService,
    $settings: SettingsValuesService,
    $operations: ProgrammableLogicController_OperationService,
    $utils: UtilsService,
    $context: ProgrammableLogicController_connectors_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ProgrammableLogicController_LocalizationService,
    $event: any
  ) {
    this.$logger.log('ProgrammableLogicController', 'connectors_grid.on_delete_clicked');
  for(let row of $grid.selectedRows){
      await $flows.ProgrammableLogicController.delete_connector({name: row.entity.name, warehouseId: row.entity.warehouseId})
  }
  
  $grid.refresh();
  }
  on_grid_data_load(event = null) {
    return this.on_grid_data_loadInternal(
      this,
  this.$shell,
      this.$datasources,
      this.$flows,
      this.$frontendFlows,
      this.$reports,
      this.$settings,
      this.$operations,
      this.$utils,
      this.$context,
      // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
      // this.localization,
      event);
  }
  async on_grid_data_loadInternal(
    $grid: ProgrammableLogicController_connectors_gridComponent,
  
    $shell: ProgrammableLogicController_ShellService,
    $datasources: ProgrammableLogicController_DatasourceService,
    $flows: ProgrammableLogicController_FlowService,
    $frontendFlows: ProgrammableLogicController_FrontendFlowService,
    $reports: ProgrammableLogicController_ReportService,
    $settings: SettingsValuesService,
    $operations: ProgrammableLogicController_OperationService,
    $utils: UtilsService,
    $context: ProgrammableLogicController_connectors_grid_ComponentContextService,
    // Localization was developed as a POC while working on a spike 123236. This $l10n is hidden for now.
    //$l10n: ProgrammableLogicController_LocalizationService,
    $event: any
  ) {
    this.$logger.log('ProgrammableLogicController', 'connectors_grid.on_grid_data_load');
  let projectName: string
  let warehouseName: string
  let orderClassName: string
  
  
  for (let row of $grid.rows) {
      if ($utils.isDefined(row.entity.projectId)) {
          projectName = (await $datasources.ProgrammableLogicController.ds_projectName_by_id.get({ id: row.entity.projectId })).result.Name
      }
      if ($utils.isDefined(row.entity.warehouseId)) {
          warehouseName = (await $datasources.Utilities.ds_get_warehouses_by_warehouseIds.get({ warehouseIds: [row.entity.warehouseId] })).result[0].Name
      }
      if ($utils.isDefined(row.entity.orderClassId)) {
          orderClassName = (await $datasources.ProgrammableLogicController.ds_get_orderclasses_by_id.get({ id: row.entity.orderClassId })).result.Name
      }
      
      row.cells.project.displayControl.text = projectName
      row.cells.warehouse.displayControl.text = warehouseName
      row.cells.order_class.displayControl.text = orderClassName
  }
  }
  //#endregion private flows


 
  close() {
    this.$finish.emit();
  }
}
